/**
 * TKP-93 / tasarım s.22 md.10–12 — metnin envanterle güncelliği.
 *
 * Sunucu her metinle birlikte `inventoryVersion` (üretim anındaki damga), `currentInventoryVersion` (organizasyonun
 * güncel sayacı) ve `staleInventory` döner. Buradaki yardımcılar saf: karar sunucuda verilir, arayüz yalnız gösterir.
 */

/** Rozet gösterilsin mi? Damgasız (eski) metinler işaretlenmez — karar. */
export const isStale = (document) => document?.staleInventory === true;

/** Rozetin ipucu: kaç sürüm geride. */
export const staleHint = (document) => {
  if (!isStale(document)) return null;
  const from = document.inventoryVersion;
  const to = document.currentInventoryVersion;
  if (typeof from !== "number" || typeof to !== "number") return null;
  return { from, to, behind: to - from };
};

/**
 * Metnin sakladığı kriter → önizleme/üretim ucunun beklediği seçim şekli.
 *
 * Saklanan biçim alan başına TEK nesne (`{ _id, name, fieldName }`) çünkü her metin kartezyenin tek birleşimidir;
 * uçlar ise çoklu seçim (dizi) bekler. `fieldName` yalnız üretim içi bir işaret, geri gönderilmez.
 */
export const criteriaToSelection = (criteria) => {
  const out = {};
  for (const [field, value] of Object.entries(criteria || {})) {
    const items = (Array.isArray(value) ? value : [value]).filter((v) => v && v._id).map((v) => ({ _id: v._id, name: v.name }));
    if (items.length) out[field] = items;
  }
  return out;
};

/** Metnin içeriği tek metin olarak (fark ekranında yan yana göstermek için). */
export const contentOf = (document) => (Array.isArray(document?.content) ? document.content.join("") : document?.content || "");

/**
 * "Farkları gör" / "Güncel envantere uyarla" çağrılabilir mi?
 *
 * YALNIZ şablon gerekir. Kriterin boş olması "filtre yok" demektir ve geçerlidir — üretim de öyle yapılmıştı
 * (kriter gönderilmezse şablonun kendi kriterleri kullanılır). Şablonu olmayan eski kayıt yenilenemez.
 */
export const canRefresh = (document) => !!document?.template?._id;
